import {useEffect, useMemo, useState} from 'react';
import {getLicenseKey} from "./api/presentations.ts";

export const UPLOADS_BASE_URL = "https://r2-dev.myidecide.net";
export const MUSIC_BASE_URL = "https://r2-dev.myidecide.net/music";

export function usePlayerConfig(): any | undefined {
	const [licenseKey, setLicenseKey] = useState<string | null>(null);

	useEffect(() => {
		(async () => {
			const key = await getLicenseKey();
			setLicenseKey(key);
		})();
	}, []);

	const config = useMemo(
		() => {

			if (!licenseKey) return undefined;

			return {
				license: licenseKey,
				baseURL: '/cesdk-assets/1.69.0',
			}
		}, [licenseKey]
	);

	return config;
}
